import React from 'react';
import styled from 'styled-components';

export const Page = styled.div`
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
`;

export const Panel = styled.section`
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  box-shadow: ${({ theme }) => theme.shadow.subtle};
  overflow: hidden;
`;

export const PanelBody = styled.div`
  padding: clamp(18px, 3vw, 30px);
`;

export const Field = styled.div`
  display: grid;
  gap: 7px;
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.text};
  font-size: 13px;
  font-weight: 650;
`;

const control = `
  width: 100%;
  min-height: 42px;
  padding: 9px 11px;
  background: white;
  border: 1px solid #c8c8c0;
  border-radius: 6px;
  color: #20201e;
  &:focus { border-color: #276749; box-shadow: 0 0 0 3px #e5f0e9; outline: none; }
  &:disabled { background: #f1f1ed; color: #6f706b; }
`;
export const Input = styled.input`${control}`;
export const Select = styled.select`${control}`;
export const Textarea = styled.textarea`${control}; min-height: 110px; resize: vertical;`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  @media (max-width: 640px) { grid-template-columns: 1fr; }
`;

export const Notice = styled.div`
  padding: 11px 13px;
  border: 1px solid ${({ $type, theme }) => $type === 'error' ? '#efc4bf' : theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.sm};
  background: ${({ $type, theme }) => $type === 'error' ? '#fff3f1' : $type === 'success' ? theme.colors.accentSoft : theme.colors.surfaceMuted};
  color: ${({ $type, theme }) => $type === 'error' ? theme.colors.danger : theme.colors.text};
`;

export const EmptyState = styled.div`
  padding: 56px 24px;
  text-align: center;
  color: ${({ theme }) => theme.colors.textMuted};
`;

export const QuestionBlock = styled.div`
  display: grid;
  gap: 9px;
  padding: 18px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  &:first-child { padding-top: 0; }
  &:last-child { border-bottom: 0; }
`;

const Choices = styled.div`display: grid; gap: 8px;`;
const Choice = styled.label`
  display: flex; align-items: center; gap: 10px; min-height: 42px; padding: 9px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: ${({ theme }) => theme.radius.sm};
  cursor: pointer; &:hover { background: ${({ theme }) => theme.colors.surfaceMuted}; }
`;
const Ratings = styled.div`display: grid; grid-template-columns: repeat(10, 1fr); gap: 6px; @media(max-width:560px){grid-template-columns:repeat(5,1fr)}`;
const Rating = styled.button`
  min-height: 38px; border: 1px solid ${({ theme }) => theme.colors.borderStrong}; border-radius: 6px;
  background: ${({ $selected, theme }) => $selected ? theme.colors.accent : theme.colors.surface};
  color: ${({ $selected, theme }) => $selected ? 'white' : theme.colors.text}; cursor: pointer;
`;

export const QuestionInput = ({ question, index, value, onChange, namePrefix = 'question' }) => {
  if (question.questionType === 'textarea') return <Textarea value={value || ''} onChange={e => onChange(index, e.target.value)} placeholder="Your response" />;
  if (question.questionType === 'rating') return <Ratings>{Array.from({ length: 10 }, (_, i) => <Rating key={i + 1} type="button" $selected={value === String(i + 1)} onClick={() => onChange(index, String(i + 1))}>{i + 1}</Rating>)}</Ratings>;
  if (question.questionType === 'multipleChoice') return <Choices>{(question.options || []).map(option => <Choice key={option}><input type="radio" name={`${namePrefix}-${index}`} checked={value === option} onChange={() => onChange(index, option)} />{option}</Choice>)}</Choices>;
  if (question.questionType === 'checkbox') return <Choices>{(question.options || []).map(option => { const values = Array.isArray(value) ? value : []; return <Choice key={option}><input type="checkbox" checked={values.includes(option)} onChange={e => onChange(index, e.target.checked ? [...values, option] : values.filter(item => item !== option))} />{option}</Choice>; })}</Choices>;
  return <Input type="text" value={value || ''} onChange={e => onChange(index, e.target.value)} placeholder="Your response" />;
};
